import { ActionCreator } from '@sendoutcards/core'

export const setIsDigitalCard = ActionCreator(
  'SET_IS_DIGITAL_CARD',
  (isDigitalCard: boolean) => ({ isDigitalCard }),
)

export const setRecipientDrawerOpen = ActionCreator(
  'SET_RECIPIENT_DRAWER_OPEN',
  (isDrawerOpen: boolean) => ({ isDrawerOpen }),
)
